import { FC, useEffect, useState } from 'react';
import './TeacherProfileForm.scss';
import { useForm, FormProvider, Resolver } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { getDecryptedDataWithSecretKey } from '../../utils/helper';
import { messages, patterns, STUDENT_ROLE } from '../../utils/constants';
import images from '../../assets/images';
import { useAppSelector } from '../../redux/app/hooks';
import InputField from '../InputField/InputField';

interface PropsType {
    id: string;
    fullName: string;
    email?: string;
    phonenumber?: string;
    username: string;
    password: string;
    avatarUrl: string;
    isEdit?: boolean;
    displayForm?: boolean;
    setDisplayForm?: (val: boolean) => void;
    isSubmit?: boolean;
    setIsEdit?: (val: boolean) => void;
}

interface IFormInput {
    fullName: string;
    email?: string;
    phonenumber?: string;
    username: string;
    password: string;
}

const schema = yup.object().shape({
    fullName: yup
        .string()
        .required(messages?.name)
        .matches(patterns?.alphabetSpace, messages?.validName)
        .max(100, 'Name should not exceed 100 characters'),
    email: yup
        .string()
        .nullable()
        .notRequired() 
        .trim()
        .test('is-valid-email', messages.validEmail, function (value) {
            const { path, createError } = this;
            if (value && value.length > 0) {
                return patterns.email.test(value) || createError({ path, message: messages.validEmail });
            }
            return true;
        }),
    phonenumber: yup
        .string()
        .test('is-valid-phoneNumber', "Phone number must be exactly 10 digits", function (value) {
            const { path, createError } = this;
            if (value && value.length > 0) {
                return patterns.phoneNumber.test(value) || createError({ path, message: "Phone number must be exactly 10 digits" });
            }
            return true;
        }),
    username: yup
        .string()
        .strict()
        .trim(messages.invalidUsername)
        .required(messages.username)
        .matches(patterns.username, messages.validUsername)
        .matches(patterns.usernameStartWithAlphabets, messages.usernameStartWithAlphabets)
        .matches(patterns.consecutiveDotsDashesUnderscores, messages.noConsecutiveDotsDashesUnderscores)
        .min(6, messages.usernameMinLength)
        .max(50, messages.usernameMaxLength)
        .test('not-only-numbers', messages.invalidUsername, value => {
            if (value) {
                return !patterns.onlyNumbers.test(value);
            }
            return true;
        }),
    password: yup
        .string()
        .strict()
        .trim(messages.invalidPassword)
        .required(messages.password)
        .matches(patterns?.password, messages?.validPassword)
        .min(8, messages.passwordMinLength)
        .max(30, messages.passwordMaxLength)
        // .matches(patterns?.upperCasePassword, messages?.passwordOneUpperCase)
        // .matches(patterns?.lowerCasePassword, messages?.passwordOneLowerCase)
        // .matches(patterns?.oneNumbers, messages?.passwordOneNumber)
        // .matches(patterns?.oneSpecialCharacter, messages?.passwordOneSpecialCharater),
});

const TeacherProfileForm: FC<PropsType> = ({id,avatarUrl,fullName,username,password}) => {
    const {  User } = images;
    const [profileImageURL, setProfileImageURL] = useState<string>();
    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const methods = useForm<IFormInput>({
        resolver: yupResolver(schema) as Resolver<IFormInput>,
    });
    const { reset } = methods;
    const role = useAppSelector((state) => state.auth.role);
    
    useEffect(() => {
        reset({
            fullName,
            username,
            password: getDecryptedDataWithSecretKey(password).originalText
        });
        setProfileImageURL(avatarUrl);
    }, [id]);
    

    return (
        <div className={`StudentProfileForm ${role === STUDENT_ROLE && 'hideOverflow'}`}>
            <div className="adminStudentFormContainer">
                <FormProvider {...methods}>
                    <form className="addStudentForm">
                        <div className='addStudentParentContainer'>
                            <div className="StudentProfileImage">
                                <div className={`${profileImageURL ? 'StudentEditContainer' : 'StudentImageContainer'}`}>
                                    <img className={`${profileImageURL ? 'StudentImageProfileStyle' : 'StudentImageDefault'}`}  alt='TeacherImage' src={profileImageURL ? baseUrl + profileImageURL : User} />
                                </div>
                            </div>
                            <div className="StudentDetails">
                                <div className="StudentNameField">
                                    <InputField label="Full Name" name="fullName" classname="subjectStyle" type="text" size="addTeacherField" isDisable={true} />
                                </div>
                                <div className="StudentNameField">
                                    <InputField label="Username" name="username" type="text" size="addTeacherField" isDisable={true} />
                                </div>
                                <div className="StudentNameField">
                                    <InputField label="Password" name="password" type="password" size="addTeacherField" isDisable={true} />
                                </div>
                            </div>
                        </div>
                    </form>
                </FormProvider>
            </div>
        </div>
    );
};

export default TeacherProfileForm;

